import {Nav, Footer} from '../components'
import CryptoJS from 'crypto-js'

import {Outlet} from 'react-router-dom'
import {useDispatch} from "react-redux";
import React, {useState} from "react";
import {adduserinfo} from "../Slices/userSlice";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Modal} from "@mui/material";
import {ArrowBackIos} from "@mui/icons-material";


const Mainlayout = ({children}) => {


    // checking to see if user exists or not in localstorage
    const dispatch = useDispatch()


    if (localStorage.getItem('userinfo')) {

        let decrypt = JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('userinfo'), 'secret key').toString(CryptoJS.enc.Utf8));


        dispatch(adduserinfo(decrypt))


    }


    setTimeout(console.log.bind(console,'%c\n' +
        '██████╗░░░░██╗░░██╗\n' +
        '██╔══██╗░░░██║░░██║\n' +
        '██████╔╝░░░███████║\n' +
        '██╔══██╗░░░██╔══██║\n' +
        '██║░░██║██╗██║░░██║\n' +
        '╚═╝░░╚═╝╚═╝╚═╝░░╚═╝ \n'+
        'developer: Ramin Hasani \n'+
        'Rhasani.com',"color: green" ));


    const [showModal,setShowmodal] = useState(true)

    const handleClose = () => {
        setShowmodal(false)

    };


    return (
        <>
            <div className='is-flex is-flex-direction-column is-align-items-center mx-auto'>


                <div className='containerwidth '>
                    <Nav/>
                    <Outlet/>


                    {children}


                </div>
                <Modal
                    open={showModal}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    className='is-flex is-justify-content-center is-align-items-center'
                >
                    <div className='has-background-white has-text-black is-flex is-flex-direction-column is-align-items-center is-justify-content-space-around px-3 ' style={{width:'66%' , minHeight:'70%'}}>
                        <img src="/images/110327624.png" style={{maxWidth:'10rem'}}  alt="logo"/>

                        <article className='has-text-black  has-text-left has-text-justified px-3 pinar'>
                            This is a Demo
                            <br/>
                            In this platform the user can see the available seats and select his/her desired ones and pay for it- The platforms admin can creat events for different theatres that have varying seating areas or arrangements
                            <br/>
                            Systems admin can change the price of each seat
                            <br/>
                            Developer:
                            <a className='has-text-black has-text-weight-bold mx-1' target='_blank' rel='author'
                               href="https://rhasani.com">
                                Ramin Hasani (click to see my portfolio)
                            </a>

                            <br/>

                            <p className='has-text-centered has-background-grey-lighter borderrad1 mt-4 has-text-weight-bold'>
                                ReactJS - Redux- Material UI - JS & ES - Bulma
                            </p>

                        </article>
                        <article className='has-text-black px-3 pinar'>
                            این یک پیشنمایش است.
                            <br/>
                            این وبسیات با استفاده از تکنولوژی React JS برای فروش بلیط برای سالن های مختلف برای رویداد های مختلف ایجاد شده است.
                            <br/>
                            ادمین این سیستم میتواند رویداد های مختلفی را ایجاد و قیمت هر صندلی در هر رویداد را به صورت جداگانه مدیریت کند.
                            <br/>


                            <br/>
                            توسعه دهنده :

                            <a className='has-text-black has-text-weight-bold mx-1' target='_blank' rel='author'
                               href="https://rhasani.com">
                                رامین حسنی (برای مشاهده اطلاعات  کلیک کنید)
                            </a>

                        </article>

                        <button onClick={handleClose}
                                className='button has-text-centered has-background-grey has-text-white mx-4 mb-3 font13 buttonhover '>
                            ادامه
                            /
                            close
                            <ArrowBackIos/>
                        </button>
                    </div>

                </Modal>

                <Footer/>

            </div>
            <ToastContainer position="top-right"
                            autoClose={4200}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={true}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="colored"/>
        </>
    )
}
export default Mainlayout